// extracted by mini-css-extract-plugin
export default {"root":"_1-B9J","white":"_2tM1S","themed":"_3hn_x"};